<template>
  <div
    destroy-on-close
    :show-close="false"
    center
    :class="dialogVisible ? 'hb-file-preview-dialog hb-file-preview-dialog-show' : 'hb-file-preview-dialog hb-file-preview-dialog-hide'"
    fullscreen
    @open="openAction"
    style="width: 100%; height: 100%"
  >
    <div style="width: 100%; height: 100%;background-color:#C0C4CC;display:flex;flex-direction:column;align-items:center;justify-content:center">
      <img
        v-if="fileType == 2"
        :src="url()"
        style="width: 100%; height: 100%; object-fit: contain"
      />
      <iframe
        v-else-if="fileType == 1 || fileType == 3"
        :src="url()"
        width="100%"
        height="100%"
      ></iframe>
      <div v-if="fileType == 0">
        当前文档格式不支持在线预览，请下载至本地预览；仅支持:{{ officeTypeList.join('、') }}
      </div>
      <div v-if="fileType == -1">文件地址错误</div>
    </div>
    <div class="handle-wrapper">
      <el-button
        type="primary"
        @click="downLoadAction"
        style="margin-right: 5px"
        >下载文件</el-button
      >
      <el-button type="danger" @click="closeAction">关闭预览</el-button>
    </div>
  </div>
</template>
    
    <script>
import { downloadFile } from "@/api/file";
export default {
  name: "HBFIlePreview",
  props: {
    dialogTitle: {
      type: String,
      default: "预览",
    },
    previewUrl: {
      default: "",
    },
    fileName: {
      default: null,
    },
  },
  data() {
    return {
      officeTypeList:[".doc",'.docx','.dotx','.dotm','.xlsx','.xls','.ppt','.pptx']
    };
  },
  computed: {
    fileType() {
      if (!this.previewUrl) {
        return -1;
      }
      // 1 doc/excel/ 2图片 3pdf
      var fileUrl = this.previewUrl || "";
      var lowerFileUrl = fileUrl.toLocaleLowerCase();
      // const officeTypeList = [".doc",'.docx','.dotx','.dotm','.xlsx','.xls','.ppt','.pptx']
      const index = this.officeTypeList.findIndex(item => lowerFileUrl.includes(item))
      if (index >= 0) {
        return 1
      }
      if (
        lowerFileUrl.includes(".png") ||
        lowerFileUrl.includes(".jpg") ||
        lowerFileUrl.includes(".jpeg") ||
        lowerFileUrl.includes(".gif")
      ) {
        return 2;
      } else if (lowerFileUrl.includes(".pdf")) {
        return 3;
      } else {
        return 0;
      }
    },
    dialogVisible: {
      get() {
        if (this.previewUrl && this.previewUrl.length > 0) {
          return true;
        } else {
          return false;
        }
      },
      set(val) {
        this.$emit("updateVisible", val);
      },
    },
  },
  methods: {
    downLoadAction() {
      if (!this.previewUrl) {
        return;
      }
      var name = "";
      if (this.fileName) {
        name = this.fileName;
      } else {
        const list = this.previewUrl.split("/");
        name = list[list.length - 1];
      }

      downloadFile(this.previewUrl, name);
    },
    url() {
      if (this.fileType == 2) {
        return this.previewUrl;
      } else if (this.fileType == 1) {
        return (
          "https://view.officeapps.live.com/op/view.aspx?src=" + this.previewUrl
        );
      } else if (this.fileType == 3) {
        return this.previewUrl;
      } else {
        return "";
      }
    },
    openAction() {},
    closeAction() {
      this.$emit("updateVisible");
    },
  },
};
</script>
    
  <style lang="scss" scoped>
.hb-file-preview-dialog-show {
  display: block;
}
.hb-file-preview-dialog-hide {
  display: none;
}
.hb-file-preview-dialog {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 1000000;
  .handle-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: fixed;
    right: 20px;
    bottom: 20px;
  }
  // .el-dialog--center .el-dialog__body {
  //   height: 100%;
  //   padding: 0;
  // }
  // .el-dialog--center .el-dialog__header {
  //   padding: 0;
  // }
}
</style>
    


// WEBPACK FOOTER //
// src/components/HBCommon/HBFilePreview/HBFilePreview.vue